import { ICoreContext } from '@msdyn365-commerce/core';
import nbNO from './nb-NO.json';
import enUS from './en-US.json';
import sv from './sv.json';

let cachedLocale: typeof enUS | null = null;

export function getLocale(langOrContext: string | ICoreContext): Readonly<typeof enUS> {
    if (cachedLocale) {
        return cachedLocale;
    }

    const lang = typeof langOrContext === 'string' ? langOrContext : langOrContext.request.locale;

    switch (lang) {
        case 'nb-NO':
            cachedLocale = { ...enUS, ...nbNO };
            break;
        case 'sv':
            cachedLocale = { ...enUS, ...sv };
            break;
        default:
            cachedLocale = enUS;
    }

    return cachedLocale;
}

export const formatString = (...args: any[]) => {
    const str = args[0];
    const params = args.filter((arg, index) => index !== 0);
    if (!str) {
        return '';
    }
    return str.replace(/%s[0-9]+/g, (matchedStr: { replace: (arg0: string, arg1: string) => number }) => {
        const variableIndex = matchedStr.replace('%s', '') - 1;
        return params[variableIndex];
    });
};
